// Quick Order Form JavaScript (FLOW: Review -> Prefill Shopify Forms -> User submits)

document.addEventListener('DOMContentLoaded', () => {
  const form = document.getElementById('quick-order-form');
  if (!form) return;

  const qtyInputs = form.querySelectorAll('.qty-input');
  const qtyBtns = form.querySelectorAll('.qty-btn');
  const variantSelects = form.querySelectorAll('.variant-select');

  const mainBtn = document.getElementById('submit-order');      // bouton "Vérifier la commande"
  const stickyBar = document.getElementById('sticky-submit-bar');
  const stickyBtn = document.getElementById('sticky-submit-btn');

  const overlay = document.getElementById('order-review-overlay');
  const list = document.getElementById('order-review-list');
  const btnEdit = document.getElementById('order-review-edit');
  const btnGenerate = document.getElementById('order-review-confirm'); // "Générer la commande"

  // -----------------------------
  // Helpers UI (erreur / succès)
  // -----------------------------
  function showError(message) {
    const errorDiv = document.getElementById('error-message');
    const errorText = document.getElementById('error-text');
    if (errorText) errorText.textContent = message;
    if (errorDiv) errorDiv.style.display = 'block';
  }

  function showSuccessPrefill() {
    const success = document.getElementById('success-message');
    if (success) success.style.display = 'block';
  }

  function escapeHtml(str) {
    return String(str)
      .replaceAll('&', '&amp;')
      .replaceAll('<', '&lt;')
      .replaceAll('>', '&gt;')
      .replaceAll('"', '&quot;')
      .replaceAll("'", '&#039;');
  }

  function openOverlay() {
    if (!overlay) return;
    overlay.style.display = 'block';
    overlay.setAttribute('aria-hidden', 'false');
    setTimeout(() => btnGenerate?.focus(), 0);
  }

  function closeOverlay() {
    if (!overlay) return;
    overlay.style.display = 'none';
    overlay.setAttribute('aria-hidden', 'true');
  }

  // -----------------------------
  // Pré-sélection: 1ère option si vide
  // -----------------------------
  variantSelects.forEach(select => {
    if (select.options.length > 0 && !select.value) {
      select.selectedIndex = 0;
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });

  // -----------------------------
  // + / - Quantité
  // -----------------------------
  qtyBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      const productId = btn.dataset.productId;
      const input = form.querySelector(`.qty-input[data-product-id="${productId}"]`);
      if (!input) return;

      const current = parseInt(input.value, 10) || 0;

      if (btn.classList.contains('qty-plus')) {
        input.value = current + 1;
      } else if (btn.classList.contains('qty-minus')) {
        input.value = Math.max(0, current - 1);
      }

      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

  // -----------------------------
  // Validation qty input
  // -----------------------------
  qtyInputs.forEach(input => {
    input.addEventListener('change', () => {
      let value = parseInt(input.value, 10) || 0;
      if (value < 0) value = 0;
      input.value = value;
    });
  });

  // -----------------------------
  // Build order data
  // -----------------------------
  function getOrderItems() {
    const items = [];
    const rows = form.querySelectorAll('.product-row');

    rows.forEach(row => {
      const productId = row.dataset.productId;
      const qtyInput = row.querySelector(`.qty-input[data-product-id="${productId}"]`);
      const qty = qtyInput ? parseInt(qtyInput.value || '0', 10) : 0;
      if (!qty || qty <= 0) return;

      const productTitle = row.dataset.productTitle || 'Produit';

      // Variant
      let variantId = null;
      let variantTitle = '';

      const variantSelect = row.querySelector('.variant-select');
      if (variantSelect && variantSelect.options.length > 0) {
        const opt = variantSelect.options[variantSelect.selectedIndex];
        variantId = opt.value;
        variantTitle = (opt.dataset.title || opt.textContent || '').trim();
      } else {
        const hidden = row.querySelector('.variant-id');
        if (hidden) variantId = hidden.value;
      }

      items.push({
        productId,
        productTitle,
        variantId,
        variantTitle,
        quantity: qty
      });
    });

    return items;
  }

  function buildOrderData() {
    const items = getOrderItems();
    const notes = document.getElementById('order-notes')?.value || '';

    return {
      customer: {
        name: window.quickOrderConfig?.customerName || '',
        email: window.quickOrderConfig?.customerEmail || '',
        phone: window.quickOrderConfig?.customerPhone || '',
        address: window.quickOrderConfig?.customerAddress || ''
      },
      items,
      notes,
      date: new Date().toLocaleString('fr-CA', {
        timeZone: 'America/Toronto',
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      })
    };
  }

  // -----------------------------
  // Modal summary
  // -----------------------------
  function renderSummary(items) {
    if (!list) return;

    if (!items.length) {
      list.innerHTML = `
        <div class="order-review-item">
          <div>
            <div class="name">Aucun item</div>
            <div class="meta">Veuillez ajouter au moins une quantité avant de continuer.</div>
          </div>
          <div class="qty">—</div>
        </div>
      `;
      if (btnGenerate) btnGenerate.disabled = true;
      return;
    }

    if (btnGenerate) btnGenerate.disabled = false;

    list.innerHTML = items.map(i => `
      <div class="order-review-item">
        <div>
          <div class="name">${escapeHtml(i.productTitle)}</div>
          ${i.variantTitle ? `<div class="meta">${escapeHtml(i.variantTitle)}</div>` : ``}
        </div>
        <div class="qty">x${i.quantity}</div>
      </div>
    `).join('');
  }

  function startReviewFlow() {
    const orderData = buildOrderData();
    if (!orderData.items.length) {
      showError('Veuillez ajouter au moins un produit à votre commande (quantité > 0).');
      return;
    }
    renderSummary(orderData.items);
    openOverlay();
  }

  // Boutons "Vérifier la commande"
  mainBtn?.addEventListener('click', startReviewFlow);
  stickyBtn?.addEventListener('click', startReviewFlow);

  // Overlay close actions
  overlay?.addEventListener('click', (e) => {
    if (e.target === overlay) closeOverlay();
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && overlay?.style.display === 'block') {
      closeOverlay();
    }
  });

  btnEdit?.addEventListener('click', closeOverlay);

  // "Générer la commande" => pré-remplit Shopify Forms, sans soumettre
  btnGenerate?.addEventListener('click', () => {
    const orderData = buildOrderData();
    if (!orderData.items.length) return;

    if (typeof window.prefillShopifyForm !== 'function') {
      showError("La fonction de pré-remplissage Shopify Forms n'est pas disponible sur cette page.");
      return;
    }

    try {
      window.prefillShopifyForm(orderData);
      closeOverlay();
      showSuccessPrefill();

      // Scroll vers le bloc du formulaire Shopify Forms
      const formsBlock =
        document.getElementById('shopify-forms-step') ||
        document.querySelector('#shopify-block-AS2FOUTc3dHpjamd0U__forms_inline_8jtMGn') ||
        document.querySelector('shopify-forms-embed');

      formsBlock?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } catch (err) {
      showError(err?.message || 'Impossible de pré-remplir le formulaire Shopify.');
    }
  });

  // -----------------------------
  // Sticky bar: show only if main button not visible
  // -----------------------------
  if (mainBtn && stickyBar && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver(([entry]) => {
      const showSticky = !entry.isIntersecting;
      stickyBar.style.display = showSticky ? 'block' : 'none';
      stickyBar.setAttribute('aria-hidden', showSticky ? 'false' : 'true');
    }, { threshold: 0.01 });

    observer.observe(mainBtn);
  }
});


// -------------------------------------
// GLOBAL: texte commande pour Shopify Forms
// -------------------------------------
window.createPlainTextVersion = function(orderData) {
  let text = `NOUVELLE COMMANDE RAPIDE - DÉTAILLANT\n\n`;
  text += `=== INFORMATIONS DU DÉTAILLANT ===\n`;
  text += `Nom: ${orderData.customer.name}\n`;
  text += `Courriel: ${orderData.customer.email}\n`;
  text += `Téléphone: ${orderData.customer.phone}\n`;
  text += `Adresse: ${orderData.customer.address}\n`;
  text += `Date: ${orderData.date}\n\n`;

  text += `=== PRODUITS COMMANDÉS ===\n`;
  orderData.items.forEach((item, index) => {
    text += `${index + 1}. ${item.productTitle}\n`;
    if (item.variantTitle) {
      text += `   Variante: ${item.variantTitle}\n`;
    }
    text += `   Quantité: ${item.quantity}\n\n`;
  });

  if (orderData.notes) {
    text += `\n=== NOTES / COMMENTAIRES ===\n`;
    text += orderData.notes + '\n';
  }

  return text;
};

/* =========================================================
   WSH Order Form – EN alphabetical sorting (client-side)
   (hide until sorted + show loading indicator)
   ========================================================= */

(function () {
  if (document.documentElement.lang !== "en") return;
  if (!window.location.pathname.startsWith("/en/apps/shop")) return;

  if (window.__QOF_WOF_SORT_INIT__) return;
  window.__QOF_WOF_SORT_INIT__ = true;

  const TABLE_SEL = "#wof_product_table";
  const PRODUCT_ROW_SEL = "tbody tr.product-row";
  const FOOTER_ROW_SEL = "tbody tr#noMoreProductsToShow";
  const TITLE_SEL = ".wof-product-title";

  function normalize(str) {
    return (str || "")
      .trim()
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/^pos\s*:?\s*/i, "");
  }

  function ensureLoader(table) {
    // Insert loader just before the table if not already there
    let loader = document.querySelector(".qof-loading");
    if (loader) return loader;

    loader = document.createElement("div");
    loader.className = "qof-loading";
    loader.innerHTML = `
      <div class="qof-spinner" aria-hidden="true"></div>
      <div>Loading products…</div>
    `;

    table.parentNode.insertBefore(loader, table);
    return loader;
  }

  function hideTbody(tbody) {
    if (tbody && tbody.dataset.qofSorted !== "true") tbody.classList.add("qof-hide");
  }

  function showTbody(tbody) {
    if (tbody) tbody.classList.remove("qof-hide");
  }

  function sortOnceWhenReady() {
    const table = document.querySelector(TABLE_SEL);
    if (!table) return false;

    const tbody = table.querySelector("tbody");
    if (!tbody) return false;

    const loader = ensureLoader(table);

    // Hide list until sorted; show loader
    if (tbody.dataset.qofSorted !== "true") {
      hideTbody(tbody);
      loader.style.display = "flex";
    }

    // Wait until WSH indicates the list is complete
    const footerRow = tbody.querySelector(FOOTER_ROW_SEL);
    if (!footerRow) return false;

    // Already done?
    if (tbody.dataset.qofSorted === "true") return true;
    tbody.dataset.qofSorted = "true";

    const productRows = Array.from(tbody.querySelectorAll(PRODUCT_ROW_SEL));
    productRows.sort((a, b) => {
      const aTitle = normalize(a.querySelector(TITLE_SEL)?.textContent);
      const bTitle = normalize(b.querySelector(TITLE_SEL)?.textContent);
      return aTitle.localeCompare(bTitle, "en", { sensitivity: "base" });
    });

    productRows.forEach(row => tbody.appendChild(row));
    tbody.appendChild(footerRow);

    // Reveal + hide loader
    showTbody(tbody);
    loader.style.display = "none";

    return true;
  }

  // Run quickly
  let attempts = 0;
  const maxAttempts = 150; // ~30s at 200ms
  const timer = setInterval(() => {
    attempts++;
    const done = sortOnceWhenReady();
    if (done || attempts >= maxAttempts) {
      clearInterval(timer);

      // Fail-safe: never leave hidden forever
      const table = document.querySelector(TABLE_SEL);
      const tbody = table && table.querySelector("tbody");
      if (tbody) showTbody(tbody);

      const loader = document.querySelector(".qof-loading");
      if (loader) loader.style.display = "none";
    }
  }, 200);
})();

/* =========================================================
   WOF Order Form – EN UI translations
   ========================================================= */

(function () {
  if (document.documentElement.lang !== "en") return;
  if (!window.location.pathname.startsWith("/en/apps/shop")) return;

  function translate() {
    const map = {
      lbl_filter: "Filters",
      lbl_sort_by: "Sort by",
      lbl_cart_total: null // number only, no label
    };

    Object.keys(map).forEach(id => {
      const el = document.getElementById(id);
      if (!el || map[id] === null) return;
      el.textContent = map[id];
    });

    const searchInput = document.getElementById("wof_txt_search");
    if (searchInput) {
      searchInput.placeholder = "Search by product name, SKU…";
    }
  }

  // Run once DOM is ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", translate);
  } else {
    translate();
  }
})();